import React from 'react';
import useResponsiveLayout from '../../../styles/responsive-layout.hook';
import HeaderComponents from './header.components';

interface HeaderContentProps {
  titleText: string[];
  contentText: string[];
  isFormPage?: boolean;
}

const {
  Container,
  LeftBox,
  MainColumn,
  TextContainer,
  Title,
  Content
} = HeaderComponents;

const HeaderContent: React.FunctionComponent<HeaderContentProps> = ({
  titleText,
  contentText,
  isFormPage
}) => {
  const { isDesktop } = useResponsiveLayout();

  return (
    <Container>
      {isDesktop && <LeftBox />}
      <MainColumn>
        <TextContainer isFormPage={isFormPage}>
          <Title
            tParams={{
              tKey: titleText
            }}
          />
          <Content
            tParams={{
              tKey: contentText
            }}
            isFormPage={isFormPage}
          />
        </TextContainer>
      </MainColumn>
    </Container>
  );
};

export default HeaderContent;
